import Vue from "vue";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import uploadApi from '../services/UploadApi.js';

function announcementImageUploadAdapter(loader) {
	const controller = new AbortController();

	return {
		upload() {
			return loader.file.then(file => {
				const data = new FormData();
				data.append('upload', file);
				return uploadApi()
					.post('/v1/admin/announcements/uploadImage', data, { signal: controller.signal })
					.then(response => ({ default: response.data.url }));
			});
		},
		abort() {
			controller.abort();
		}
	};
}

Vue.component("wto-ck-editor", {
	props: ["viewModelData", "hasSource", "mediaTools"],
	computed: {
		computedValue: {
			get() {
				return !this.viewModelData ? "" : this.viewModelData;
			},
			set(value) {
				this.$emit("update:viewModelData", value);
			}
		},
		editorConfig() {
			let returnValue = {
				toolbar: {
					items: ['bold', 'italic', 'subscript', 'superscript', 'link', '|', 'bulletedList', 'numberedList', 'outdent', 'indent', '|', 'insertTable',  '|', 'undo', 'redo']
				},
				table: {
					contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
				}
			};

			if (this.hasSource) {
				returnValue = {
					toolbar: {
						items: ['bold', 'italic', 'subscript', 'superscript', 'link', '|', 'bulletedList', 'numberedList', 'outdent', 'indent', '|', 'sourceEditing', 'mediaEmbed', 'insertImage', '|', 'insertTable', '|', 'undo', 'redo']
					},
					table: {
						contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
					}
				};
			}
			else if (this.mediaTools) {
				returnValue = {
					toolbar: {
						items: ['bold', 'italic', 'link', '|', 'bulletedList', 'numberedList', 'outdent', 'indent', '|', 'mediaEmbed', 'uploadImage', '|', 'insertTable', '|', 'undo', 'redo']
					},
					table: {
						contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
					},
					mediaEmbed: {
						previewsInData: true
					}
				};
			}

			return returnValue;
		},
	},
	data() {
		return {
			editor: ClassicEditor
		};
	},
	methods: {
		onEditorReady(editor) {
			if (this.mediaTools && editor.plugins.has('FileRepository')) {
				editor.plugins.get('FileRepository').createUploadAdapter = (loader) => announcementImageUploadAdapter(loader);
			}
		}
	},
	template: `
	   <ckeditor tag-name="textarea" :editor="editor" v-model="computedValue" :config="editorConfig" @ready="onEditorReady" expanded></ckeditor>
	`
});
